/**
 * Documentation page content, transcribed from the live qost.ai/docs.
 */

export const docsPage = {
  eyebrow: "Documentation",
  title: "Qost.ai Documentation",
  intro:
    "Everything you need to connect your AWS account, understand your savings reports, and get the most out of Qost.ai.",
  primaryCta: { label: "Get Started", href: "https://app.qost.ai/register" },
  secondaryCta: { label: "API Reference", href: "/api-reference" },

  gettingStartedHeading: "Getting Started",
  gettingStartedIntro: "Be up and running in under 10 minutes.",
  steps: [
    {
      step: "01",
      title: "Create your account",
      body: "Sign up at app.qost.ai/register with your work email. No credit card required for the Starter plan.",
    },
    {
      step: "02",
      title: "Connect your AWS account",
      body: "Deploy our read-only CloudFormation stack with a single click. Takes under 5 minutes.",
    },
    {
      step: "03",
      title: "Receive your first analysis",
      body: "Within 48 hours, Qost.ai delivers your personalized savings report with actionable recommendations.",
    },
    {
      step: "04",
      title: "Implement & save",
      body: "Review prioritized recommendations and apply them with one-click or hand them to your team.",
    },
  ],

  topicsHeading: "Browse by Topic",
  topicsIntro: "Detailed guides for every feature and configuration option.",
  /** `badge` is the tag shown above each topic on the live site. */
  topics: [
    {
      badge: "Setup",
      title: "AWS Connection",
      items: [
        "CloudFormation stack deployment",
        "IAM Role and permissions",
        "Multi-account setup",
        "Revoking access",
      ],
    },
    {
      badge: "Core",
      title: "Cost Analysis",
      items: [
        "Understanding your savings report",
        "Cost breakdown by service",
        "Historical trends",
        "Budget alerts",
      ],
    },
    {
      badge: "Pro",
      title: "Recommendations",
      items: [
        "Reserved Instance suggestions",
        "Savings Plans optimization",
        "Rightsizing EC2 instances",
        "Identifying zombie resources",
      ],
    },
    {
      badge: "All Plans",
      title: "Alerts & Monitoring",
      items: [
        "Anomaly detection setup",
        "Spend threshold alerts",
        "Slack and email notifications",
        "Custom alert rules",
      ],
    },
    {
      badge: "Enterprise",
      title: "Account & Settings",
      items: [
        "Team member management",
        "Billing and subscription",
        "Notification preferences",
        "Data export options",
      ],
    },
    {
      // No badge on the live page for this one.
      badge: null,
      title: "Security & Compliance",
      items: [
        "SOC 2 Type II overview",
        "Data residency",
        "SSO and SAML setup",
        "Audit logs",
      ],
    },
  ],

  faqHeading: "Common Questions",
  faqs: [
    {
      q: "What AWS permissions does Qost.ai need?",
      a: "Qost.ai only requires read-only permissions via an IAM Role. We use a pre-built CloudFormation template to set this up securely in minutes.",
    },
    {
      q: "Can I connect multiple AWS accounts?",
      a: "Yes. Pro plan supports up to 10 accounts. Enterprise supports unlimited accounts with centralized management.",
    },
    {
      q: "How is my data stored and protected?",
      a: "All data is encrypted at rest (AES-256) and in transit (TLS 1.2+). We are SOC 2 Type II certified. See our Privacy Policy for full details.",
    },
    {
      q: "How do I export my savings report?",
      a: "From the dashboard, go to Reports → Export. You can export as CSV, PDF, or send directly to Slack or email.",
    },
  ],

  helpHeading: "Need help? Talk to a cloud expert.",
  helpBody:
    "Qost.ai is backed by Cloudlaya's team of certified AWS engineers. If you're stuck, we're just a message away.",
  helpCta: { label: "Contact Support", href: "/contact" },
};
